package co.uk.sacursoftware.ssinventory.ui

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp

private val LightColorScheme = lightColorScheme(
    primary = Color.Black,
    onPrimary = Color.White,
    secondary = Color(0xFFE52321), // Boo Red
    onSecondary = Color.White,
    background = Color.White,
    onBackground = Color.Black,
    surface = Color.White,
    onSurface = Color.Black,
    surfaceVariant = Color(0xFFF0F0F0),
    onSurfaceVariant = Color(0xFF5F5F5F),
    outline = Color.Black,
    primaryContainer = Color(0xFFF0F0F0),
    onPrimaryContainer = Color.Black,
    secondaryContainer = Color(0xFFFFEBEE),
    onSecondaryContainer = Color.Black
)

private val DarkColorScheme = darkColorScheme(
    primary = Color.White,
    onPrimary = Color.Black,
    secondary = Color(0xFFEF5350),
    onSecondary = Color.Black,
    background = Color.Black,
    onBackground = Color.White,
    surface = Color(0xFF121212),
    onSurface = Color.White,
    surfaceVariant = Color(0xFF2A2A2A),
    onSurfaceVariant = Color(0xFFC7C7C7),
    outline = Color(0xFFBDBDBD),
    error = Color(0xFFEF9A9A),
    primaryContainer = Color(0xFF2A2A2A),
    onPrimaryContainer = Color.White,
    secondaryContainer = Color(0xFF3D1F1F),
    onSecondaryContainer = Color(0xFFFFCDD2)
)

@Composable
fun successContainerColor(): Color =
    if (isSystemInDarkTheme()) Color(0xFF14331C) else Color(0xFFE8F5E9)

@Composable
fun successContentColor(): Color =
    if (isSystemInDarkTheme()) Color(0xFF81C784) else Color(0xFF2E7D32)

@Composable
fun successOnContainerColor(): Color =
    if (isSystemInDarkTheme()) Color(0xFFC8E6C9) else Color(0xFF1B5E20)

@Composable
fun SSInventoryTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit
) {
    val colorScheme = if (darkTheme) DarkColorScheme else LightColorScheme

    MaterialTheme(
        colorScheme = colorScheme,
        shapes = Shapes(
            small = RoundedCornerShape(4.dp),
            medium = RoundedCornerShape(8.dp),
            large = RoundedCornerShape(12.dp)
        ),
        content = content
    )
}
